import { type Customer } from '@hungryroot/customer';
import { FoodProfileDisclosure } from '@hungryroot/page-food-profile';
import { type Tag } from '@hungryroot/rest';
import { tagGroups, getTagDetails } from '@hungryroot/tags';
import {
  useCustomerTagGroup,
  type CustomerTagGroupResponse,
} from '@hungryroot/tags';
import { Heading, Paragraph, Cuisines } from '@hungryroot/ui-kit';
import {
  ControlTagSwitch,
  TagPreference,
} from '../ControlTagSwitch/ControlTagSwitch';
import styles from './ReadyMadeSection.module.css';

interface Props {
  testid?: string;
  customerId: Customer['id'];
}

function getSubtitle(customerTags: CustomerTagGroupResponse | undefined) {
  if (!customerTags) {
    return;
  }

  const selectedTagDetails = customerTags.results
    .filter((pref) => pref.preference === TagPreference.Selected)
    .map((pref) => {
      return getTagDetails({ id: pref.tag } as Tag);
    });
  const tagNames = selectedTagDetails?.map((pref) => pref.name);
  return tagNames?.join(', ');
}

export function ReadyMadeSection(props: Props) {
  const { testid, customerId } = props;

  const { data: customerTagGroupData } = useCustomerTagGroup(
    tagGroups.readyMade
  );
  const subtitle = getSubtitle(customerTagGroupData);

  return (
    <section data-testid={testid} className={styles.container}>
      <FoodProfileDisclosure
        testid={`${testid}-disclosure`}
        title="Prepared meals"
        subtitle={subtitle || 'Set your preferences.'}
        icon={<Cuisines />}
        deepLink="ready-made-preferences"
      >
        <Heading variant="H5">What kind of prepared meals do you like?</Heading>
        <Paragraph className={styles.text}>
          We’ll use your preferences to suggest meals that suit your tastes.
        </Paragraph>
        <ControlTagSwitch
          testid={`${testid}-control`}
          customerId={customerId}
          colCount={2}
          tagGroupId={tagGroups.readyMade}
        />
      </FoodProfileDisclosure>
    </section>
  );
}
